import { gql } from '@apollo/client/core'

export const SEARCH_CLINICS_QUERY = gql`
  query SearchClinics($input: ClinicSearchInput!) {
    search {
      clinics(input: $input) {
        totalCount
        # eslint-disable-next-line @graphql-eslint/require-selections
        data {
          name
          phone
          fax
          hin
          websiteUrl
          status
          address {
            street1
            street2
            city
            state
            postcode
            phone1
          }
        }
      }
    }
  }
`
